export default __webpack_public_path__ + "static/media/Meals.21fb6cfc.svg";